import {useAuth0} from "@auth0/auth0-react";
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
    btnContainer: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-around",
        width: "400px",
    },
    btnLogin: {
        borderRadius: "60px",
        color: "#ffffff",
        background: "#000000",
        border: "solid #000000 2px",
        fontFamily: "EncodeSansBold",
        '&:hover': {
            background: "#bb0d67",
            border: "solid #bb0d67 2px",
        },
        fontSize: "20px",
        padding: "8px 24px",
        height: "48px",
    }
}))

const LoginButton = () => {
    const {loginWithRedirect} = useAuth0();
    const classes = useStyles();

    return (
        <div className={classes.btnContainer}>
            <button className={classes.btnLogin} onClick={loginWithRedirect}>INGRESAR</button>
        </div>
    );
};

export default LoginButton;
